<template>
  <div class="ba-node-report" :class="[{ bookmarked: pageData.bookmark }, domain.shared]" ref="nodeReport">
    <div class="report-header">
      <div v-if="group !== false" class="group">
        <div v-if="pageData.tagInfo && pageData.tagInfo[group].tagId > -1">
          <span class="tag-bullet">
            <span :style="{ background: pageData.tagInfo[group].colorHex }"></span>
          </span><span class="tag-name">
            {{ pageData.tagInfo[group].tagName || '' | onlySubdomain(journeyOptions.domain) }}
          </span>
        </div>
        <div v-else class="upcoming">
          <span class="tag-bullet">
            <i class="icon icon--upcoming-white"></i>
          </span><span class="tag-name">
            {{ $t('group.upcoming') }}
          </span>
        </div>
      </div>
      <template v-if="!isCustomNode">
        <div class="category-wrap" v-if="journeyOptions.matchType !== 'exact'">
          <div class="title">
            <i class="icon icon--ai-report-logo"></i>
            <span class="text">{{ $t('journey.nodeReport.AIPageType') }}</span>
          </div>
          <div class="category-detail" :class="[isCategoryNotEtc(pageData.AICategory1 ? pageData.AICategory1 : pageData.AICategory1, 2) ? pageData.AICategory1 ? pageData.AICategory1 : pageData.AICategory1 : 'etc']">
            <div class="secondary">
              <i class="icon" :class="[isCategoryNotEtc(pageData.AICategory1 ? pageData.AICategory1 : pageData.AICategory1, 2) ? `icon-${pageData.AICategory1 ? pageData.AICategory1 : pageData.AICategory1}` : 'icon-etc']"></i>
              <p class="secondary-title">{{ findCategoryName(pageData.AICategory1 ? pageData.AICategory1 : pageData.AICategory1, 2) }}</p>
            </div>
            <div class="line"></div>
            <div class="detail-wrap">
              <template  v-if="pageData.AICategory2 && pageData.AICategory2.length !== 0 || pageData.AICategory2 && pageData.AICategory2.length !== 0">
                <div class="tertiary" v-for="(item, index) in pageData.AICategory2 ? pageData.AICategory2 : pageData.AICategory2" :key="index">
                  <i class="icon" :class="[isCategoryNotEtc(item, 3) ? `icon-tertiary-${item}` : 'icon-etc']"></i>
                  <p class="tertiary-title">{{ findCategoryName(item, 3) }}</p>
                </div>
              </template>
              <template v-else>
                <div class="tertiary" >
                  <p class="tertiary-title">{{ $t(`common.category3.noData`) }}</p>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="url" v-if="!isCustomNode">
          <a :href="pageData.url" target="_blank">
          <span class="title" :class="{noTitle: !pageData.title}">
            <i class="icon icon--ba-link gray"></i>
            {{ pageData.title ? pageData.title : 'No page title' }}
          </span>
          </a>
          <span class="link">
            {{ pageData.linkUrl }}
          </span>
          <template>
            <ui-bookmark-button :bookmarked="pageData.bookmark"
                                :disabled="isDemo"
                                @click="toggleFavorite" />
          </template>
        </div>
      </template>
      <template v-else>
        <div class="group">
          <span class="tag-bullet">
              <span :style="{ background: pageData.customColor }"></span>
          </span>
          <span class="tag-name custom">
            {{ pageData.customId === 0 ? $t('customTag.untaggedLabel'): pageData.customValue}}
          </span>
        </div>
      </template>

      <template v-if="reportView === 'trend'">
        <node-report-targeting-button :visible="!!pageData.bookmark || (isCustomNode && pageData.customId !== 0)"
                                      :isTracking="isTracking"
                                      :isCustomNode="isCustomNode"
                                      :gUrlId="isCustomNode ? pageData.customId : (pageData.gUrlId || pageData.key)"
                                      :nodeData="pageData" />

      </template>
      <template v-else>
        <div class="button-wrap">
          <node-report-targeting-button
              :disabled="isCustomNode ? (pageData.customId===0): !pageData.bookmark"
              :isCustomNode="isCustomNode"
              :visible="true"
              :isTracking="isTracking"
              :gUrlId="isCustomNode ? pageData.customId : (pageData.gUrlId || pageData.key)"
              :nodeData="pageData" />
          <div class="heatmap" :class="{'disabled': !!heatmapDisableType || isCustomNode}">
            <ui-button  @click="$emit('onHeatmap', pageData)"
              :iconName="!!heatmapDisableType || isCustomNode ? 'icon--heatmap-on disabled':'icon--heatmap-on'" :disabled="!!heatmapDisableType || isCustomNode">
              {{$t('common.heatmap')}}
            </ui-button>
            <ui-icon-tooltip v-if="heatmapDisableType || isCustomNode" :iconSize="'outline-white'" arrowBottom arrowRight>
              <span v-if="!isCustomNode" v-html="$t(`heatmap.disable.tip.${heatmapDisableType}`)"></span>
              <span v-else v-html="$t('customTag.nodeReport.heatmapDisabled')"></span>
            </ui-icon-tooltip>
          </div>
        </div>
      </template>

      <div class="thumbnail-carousel">
        <div class="thumbnail-container">
          <div class="thumbnail-wrap custom" v-if="isCustomNode">
            <div class="thumbnail desktop">
              <div class="image custom" :style="{'background-color': pageData.customColor}">
                <div class="value">
                  <span>{{ pageData.customId === 0 ? $t('customTag.untaggedLabel'): pageData.customValue }}</span>
                </div>
                <div class="meta">
                  <span>{{ $t('customTag.nodeReport.noScreen') }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="thumbnail-wrap" v-else
               :style="[{'width': `${100 * carouselLength}%`}, { 'margin-left': `-${100 * carouselPosition}%` }]">
            <div v-for="device in captureList"
                 class="thumbnail"
                 :class="[ device, { 'no-thumbnail': !imagePath[device] }]"
                 :style="{'width': `${100 / carouselLength}%`}"
                 :key="`thumb-${device}`">
              <p class="alert" v-if="!imagePath[device]">
                <i class="icon icon--ring"></i>
                <span v-html="$t('journey.noScreenshot')"></span>
              </p>
              <div class="image">
                <transition name="fade">
                  <div class="loading" v-show="capturing">
                    <span class="loading-circle">
                      <svg x="0px" y="0px" viewBox="0 0 150 150">
                        <circle class="loading-inner" cx="75" cy="75" r="60"/>
                      </svg>
                    </span>
                  </div>
                </transition>
                <div class="capture"
                     :style="{ 'background-image': `url('${getS3Url(imagePath[device] || defaultThumbnail)}')` }"></div>
                <div class="meta"
                     v-if="imagePath[device]">
                  <template v-if="captureType(imagePath[device]) === 'upload'">
                    {{ $t('journey.uploadDate') }}:
                  </template>
                  <template v-else>
                    {{ $t('journey.captureDate') }}:
                  </template>
                  {{ captureDate(realCaptureDate[device]) }}
                  <button v-if="!capturing"
                          @click="onCapture(device)" :class="{disabled: isDemo}">
                    <i class="icon icon--retake-white"></i>
                    {{ $t('common.retake') }}
                  </button>
                </div>
                <div class="buttons" v-else>
                  <button v-if="!capturing"
                          @click="onCapture(device)" :class="{disabled: isDemo}">
                    <i class="icon icon--retake-white"></i>
                    {{ $t('journey.screenshot') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <template v-if="!isCustomNode">
          <template v-if="carouselLength > 1">
            <button class="move left"
                    :disabled="carouselPosition < 1"
                    @click="moveCarouselLeft">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                <path fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.073 2.5L5 8 10.073 13.527" />
              </svg>
            </button>
            <button class="move right"
                    :disabled="carouselPosition > 1"
                    @click="moveCarouselRight">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                <path fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11.073 2.5L6 8 11.073 13.527" transform="matrix(-1 0 0 1 17.073 0)"/>
              </svg>
            </button>
          </template>

          <div class="bullets">
            <span v-for="idx in Array.from({ length: carouselLength }, (_, i) => i)"
                  class="bullet"
                  :class="{ active: carouselPosition === idx }"
                  :key="`bullet${idx}`"
                  @click="moveCarousel(idx)"></span>
          </div>
        </template>
      </div>
    </div>

    <div v-if="pageData.thruData" class="report-body">
      <div class="session">
        <ba-node-report-thru-info :highlightedSequenceIndex="pageData.highlightedSequenceIndex"
                                  :highlightedNodeIndex="pageData.highlightedNodeIndex"
                                  :highlightedNodeInfo="pageData.highlightedNodeInfo" />
        <h3>
          <i class="icon icon--ba-session"></i>
          <span class="text">{{ $t('common.session') }}</span>
          <ui-tooltip arrowBottom>
            <span v-html="$t('journey.description.session')"></span>
          </ui-tooltip>
        </h3>
        <div class="total">
          <div class="value">
            <!-- <i class="icon icon--ba-session-arrow"></i> -->
            <template v-if="pageData.sessCntIsInaccurate">
              <span class="invalid-value" v-html="$t('common.invalidValueDesc')"></span>
            </template>
            <template v-else >
              <span v-if="pageData.thruData.sessCntIsInaccurate" class="invalid-value" v-html="$t('common.invalidValueDesc')"></span>
              <span v-else>{{ (getComputedThruSessCnt || 0) | letterThousandMillion(0) }}</span>
              <span class="all">
                / {{ getComputedSessCnt | letterThousandMillion(0) }}
              </span>
            </template>
          </div>
        </div>
        <ul class="more-info with-thru-info">
          <li class="dropoff"
              :class="$i18n.locale">
            <h4>
              <span v-html="$t('common.dropOff')"></span>
              <ui-tooltip arrowBottom>
                <span v-html="$t('journey.description.dropOff')"></span>
              </ui-tooltip>
            </h4>
            <div class="value">
              <span class="rankCount">
                {{ (getComputedThruDropCnt || 0) | letterThousandMillion(0) }}
                <span class="percent">({{ (pageData.thruData.dropOff || 0) | fixedInt(2, 1) }}%)</span>
              </span>
              <span class="rankCount all">
                / {{ getComputedDropCnt || 0 | letterThousandMillion(0) }}
                <span class="percent">({{ pageData.dropOff | fixedInt(2, 1) }}%)</span>
              </span>
              <i :class="'icon icon--dropoff-' + getStyle('dropOff', pageData.thruData.dropOff)"></i>
            </div>
          </li>
        </ul>
      </div>
      <back-to-top :refName="'nodeReport'" :hideLabel="true" />
    </div>
    <div v-else class="report-body">
      <div class="session">
        <h3>
          <i class="icon icon--ba-session"></i>
          <span class="text">{{ $t('common.session') }}</span>
          <ui-tooltip arrowBottom>
            <span v-html="$t('journey.description.session')"></span>
          </ui-tooltip>
        </h3>
        <div class="total">
          <div class="value" >
            <template v-if="pageData.sessCntIsInaccurate">
              <span class="invalid-value" v-html="$t('common.invalidValueDesc')"></span>
            </template>
            <span v-else>{{ getComputedSessCnt | letterThousandMillion(0) }}</span>
          </div>
          <div v-if="!pageData.isTrend" class="toggle-btn url-include">
            <button class="" :class="{show: showIncludeUrl}" @click="toggleIncludeUrls">
                {{ $t('journey.nodeReport.includeUrl.title') }}
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                  <g fill="none" fill-rule="evenodd">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M2.883 5.21L7 8.689" transform="translate(-1376 -1170) translate(1070 548) translate(251 616) translate(55 6)"/>
                    <path stroke-linecap="round" stroke-linejoin="round" d="M7 5.21L11.117 8.689" transform="translate(-1376 -1170) translate(1070 548) translate(251 616) translate(55 6) matrix(-1 0 0 1 18.117 0)"/>
                  </g>
                </svg>
            </button>
          </div>
        </div>
        <div v-if="!pageData.isTrend" class="include-url-wrap">
          <IncludeUrl :loading="includeLoading" :state="showIncludeUrl" :include-data="includeUrlData" />
        </div>
        <ul class="more-info">
          <li class="time">
            <h4>
              {{ $t('common.duration') }}
              <ui-tooltip arrowBottom>
                <span v-html="$t('journey.description.duration')"></span>
              </ui-tooltip>
            </h4>
            <div class="value">
              <span class="rankCount">{{ timeString }}</span>
              <span class="rank">{{ getRank('sessionTime', pageData.sessTime) }}</span>
              <i :class="'icon icon--hourglass-' + getStyle('sessionTime', pageData.sessTime)"></i>
            </div>
          </li>
          <li v-if="pageData.dropCnt !== undefined"
              class="dropoff"
              :class="$i18n.locale">
            <h4>
              <span v-html="$t('common.dropOff')"></span>
              <ui-tooltip arrowBottom>
                <span v-html="$t('journey.description.dropOff')"></span>
              </ui-tooltip>
            </h4>
            <div class="value">
              <span class="rankCount">
                {{ getComputedDropCnt || 0 | letterThousandMillion(0) }}
                <span class="percent">({{ pageData.dropOff | fixedInt(2, 1) }}%)</span>
              </span>
              <span class="rank">{{ getRank('dropOff', pageData.dropOff) }}</span>
              <i :class="'icon icon--dropoff-' + getStyle('dropOff', pageData.dropOff)"></i>
            </div>
          </li>
        </ul>
        <div class="pageview">
          <ul class="more-info">
            <li class="refresh">
              <h4 :class="$i18n.locale">
                {{ $t('common.refresh') }}
                <ui-tooltip arrowBottom>
                  <span v-html="$t('journey.description.refresh')"></span>
                </ui-tooltip>
              </h4>
              <div class="value">
                <span class="description" :class="$i18n.locale" v-html="$t('journey.perSession', { value: (pageData.repeat.toFixed(1)) + '%' })">
                </span>
                <span class="rank">{{ getRank('repeat', pageData.repeat) }}</span>
                <i class="icon icon--refresh"></i>
              </div>
            </li>
            <li v-if="pageData.rollback !== undefined" class="rollback">
              <h4  :class="$i18n.locale">
                {{ $t('common.rollback') }}
                <ui-tooltip arrowBottom>
                  <span v-html="$t('journey.description.rollback')"></span>
                </ui-tooltip>
              </h4>
              <div class="value">
                <div class="per">
                  <span class="description" :class="$i18n.locale" v-html="$t('journey.perSession', { value: (pageData.rollback.toFixed(1)) + '%' })">
                  </span>
                  <span class="rank">{{ getRank('rollback', pageData.rollback) }}</span>
                  <i class="icon icon--rollback-new-bold"></i>
                </div>
                <div class="see-rank" v-if="pageData.rollCnt > 0">
                  <button :class="{ active: rollbackRanking }"
                          @click="toggleRollbackRanking">
                    {{ $t('common.seeUrl') }}
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                      <g fill="none" fill-rule="evenodd">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M2.883 5.21L7 8.689" transform="translate(-1376 -1170) translate(1070 548) translate(251 616) translate(55 6)"/>
                        <path stroke-linecap="round" stroke-linejoin="round" d="M7 5.21L11.117 8.689" transform="translate(-1376 -1170) translate(1070 548) translate(251 616) translate(55 6) matrix(-1 0 0 1 18.117 0)"/>
                      </g>
                    </svg>
                  </button>
                </div>
              </div>
            </li>
            <li v-if="pageData.nullity !== undefined && useNullity"
                class="nullity"
                :class="$i18n.locale">
              <h4>
                <span v-html="$t('journey.targeting.nullityJourneyMultiline')"></span>
                <ui-tooltip arrowBottom>
                  <span v-html="$t('journey.targeting.nullityJourneyInfo')"></span>
                </ui-tooltip>
              </h4>
              <div class="value">
                <span class="percent">{{ getPercentage(pageData.nullityCnt, pageData.cnt) | fixed(1) }}%</span>
                <span v-html="$t('journey.ofPvs', { value: '' })"></span>
                <span class="description sub">
                  ({{ $t('journey.perSession', { value: (pageData.nullity.toFixed(1)) + '%' }) }})
                </span>
                <span class="rank">{{ getRank('nullity', pageData.nullity) }}</span>
                <i :class="'icon icon--nullity'"></i>
              </div>
            </li>
          </ul>
          <div class="ranking"
              v-if="pageData.rollback !== undefined && pageData.rollCnt > 0"
              :class="{ hidden: rankingHeight < 1 }"
              :style="{ height: rankingHeight + 'px' }">
            <div class="loading"
                :class="{ disabled: referMap && referMap.length > 0,
                          free: !journeyOptions.isContainPaid }">
              <div class="for-free"
                  v-if="referMap && !referMap.length">
                <i class="icon icon--calendar-warning"></i>
                <p v-html="$t('journey.rollbackFromUrls.forFree')"></p>
              </div>
              <div class="loader" v-else>
                <ba-loading :showLoadingText="true" />
              </div>
            </div>
            <div class="referMap"
                :class="{ disabled: !referMap }"
                ref="referMap">
              <p class="notice" v-if="this.journeyOptions.isContainPaid">
                <i class="icon icon--bell"></i>
                <span v-html="$t('journey.rollbackFromUrls.forPro')"></span>
              </p>
              <table>
                <thead>
                <tr>
                  <th class="item--rank">{{ $t('common.rank') }}</th>
                  <th class="item--url">{{ $t('journey.rollbackFromUrls.title') }}</th>
                  <th class="item--session">{{ $t('common.pv') }}</th>
                </tr>
                </thead>
                <tbody>
                  <tr v-for="refer in referMap" :key="`ranking${refer.rank}`">
                    <td class="item--rank" :class="{ big: refer.rank > 999 }">
                      {{ refer.rank }}
                    </td>
                    <td class="item--url">
                      <a :href="`http://${refer.url}`" target="_blank" v-if="refer.url && refer.url !== 'Direct'">
                        <span class="url">{{ refer.url }}</span>
                      </a>
                      <span v-else class="url">Direct</span>
                    </td>
                    <td class="item--session" :class="{ big: refer.session > 999999 }">
                      {{ getNodePv(refer.session) | thousand }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <back-to-top :refName="'nodeReport'" :hideLabel="true" />
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { EventBus } from '@/libs/event-bus'
import {
  getPercentage,
  getS3Url,
  getS3CaptureType,
  getTimeString,
  getFromPageKey,
  getJourneyNodeKey,
  dateFormatTimezone,
  utcToLocalTimezone, getDomainForView
} from '@/libs/utils'

import { getReferMap, getIncludeUrls, getTargetIncludeUrls } from '@/api/journey'
import { getRollbackRefers as getTrendReferMap } from '@/api/trend'
import { updateBookmark } from '@/api/ranking'

import UiTooltip from '@/components/ui/UiTooltip'
import UiBookmarkButton from '@/components/ui/UiBookmarkButton'
import BackToTop from '@/components/ui/BackToTop'
import BaLoading from '@/components/ui/ba/Loading'
import BaNodeReportThruInfo from '@/components/trend/NodeReportThruInfo'
import NodeReportTargetingButton from '@/components/targeting/NodeReportTargetingButton'
import UiButton from '@/components/ui/UiButton.vue'
import UiIconTooltip from '@/components/ui/UiIconTooltip.vue'
import { differenceInDays, format } from 'date-fns'
import { HEATMAP_STATE, AI_CATEGORY_SECONDARY, AI_CATEGORY_TERTIARY } from '@/libs/constants'

import IncludeUrl from './IncludeUrl.vue'

export default {
  name: 'NodeReport',
  components: {
    UiIconTooltip,
    UiButton,
    UiTooltip,
    UiBookmarkButton,
    BackToTop,
    BaLoading,
    BaNodeReportThruInfo,
    NodeReportTargetingButton,
    IncludeUrl
  },
  computed: {
    ...mapState([
      'planData',
      'journeyPeriod',
      'journeyOptions',
      'journeyTargetingOptions',
      'numBookmarks',
      'numMaxBookmarks',
      'domain',
      'isSampling',
      'isDemo'
    ]),
    isExactMatchType () {
      return this.domain.matchType === 'exact' || this.journeyOptions.matchType === 'exact'
    },
    reportView () {
      return this.$route.name
    },
    isHeatmapAvailableRange () {
      const start = this.journeyPeriod.start
      const end = this.journeyPeriod.end
      const startDate = new Date(start)
      const endDate = new Date(end)

      const diffDay = differenceInDays(endDate, startDate) + 1
      return diffDay <= 31
    },
    isSamplingOptions () {
      return this.isSampling && (!this.journeyOptions.survey || this.journeyOptions.survey === {})
    },
    getComputedDropCnt () {
      // return this.isSamplingOptions ? this.pageData.resampleDropCnt : this.pageData.dropCnt
      return this.pageData.dropCntIsInaccurate ? this.$t('common.invalidValue') : this.pageData.dropCnt
    },
    getComputedThruDropCnt () {
      // return this.isSamplingOptions ? this.pageData.thruData.dropCnt / this.originData.sessionSamplingRate : this.pageData.thruData.dropCnt
      return this.pageData.thruData.dropCntIsInaccurate ? this.$t('common.invalidValue') : this.pageData.thruData.dropCnt
    },
    getComputedThruSessCnt () {
      return this.pageData.thruData.sessCntIsInaccurate ? this.$t('common.invalidValueDesc') : this.pageData.thruData.sessCnt
    },
    getComputedSessCnt () {
      return this.pageData.sessCntIsInaccurate ? this.$t('common.invalidValueDesc') : this.pageData.sessCnt
    },
    getComputedCnt () {
      return this.isSamplingOptions ? this.pageData.resampleCnt : this.pageData.cnt
    },
    capturing () {
      let data
      if (this.journeyOptions.matchType !== 'exact' && this.pageData.key && typeof this.pageData.key === 'string' && this.pageData.key.indexOf('|') > -1) {
        // trend, targeting
        data = getFromPageKey(this.pageData.key)
      } else {
        // ranking, journey
        data = {
          ...this.pageData,
          urlId: this.pageData.gUrlId || this.pageData.key,
          sid: this.journeyOptions.sid,
          matchType: this.journeyOptions.matchType
        }
      }
      return this.captureProcessing && this.captureProcessing.urlId === data.urlId
    },
    device () {
      return this.journeyOptions.device
    },
    imagePath () {
      return this.pageData.imagePath || {}
    },
    pvChartOptions () {
      const datas = []
      const colors = []
      datas.push({
        name: 'refresh',
        value: this.pageData.reloadCnt || 0
      })
      colors.push('#70a5f8')
      if (this.pageData.rollback !== undefined) {
        datas.push({
          name: 'rollback',
          value: this.pageData.rollCnt || 0
        })
        colors.push('#845fdb')
      }
      if (this.pageData.nullity !== undefined) {
        datas.push({
          name: 'nullity',
          value: this.pageData.rollCnt || 0
        })
        colors.push('#767676')
      }
      datas.push({
        name: 'default',
        value: this.pageData.cnt - (this.pageData.reloadCnt || 0) - (this.pageData.rollback !== undefined ? this.pageData.rollCnt || 0 : 0) - (this.pageData.nullity !== undefined ? this.pageData.nullityCnt || 0 : 0)
      })
      colors.push('#d8d8d8')
      let sumValues = 0
      datas.forEach((data) => {
        sumValues += data.value
      })
      if (!sumValues) {
        datas[datas.length - 1].value = 1
      }
      return {
        series: [
          {
            type: 'pie',
            data: datas,
            hoverAnimation: false,
            cursor: 'default',
            label: {
              show: false
            },
            tooltip: {
              show: false
            },
            silent: true,
            radius: ['35%', '100%'],
            width: 140,
            height: 140
          }
        ],
        color: colors
      }
    },
    timeString () {
      return getTimeString(this.pageData.sessTime)
    },
    carouselLength () {
      return this.device ? 1 : 3
    },
    captureList () {
      return this.device ? [this.device] : ['desktop', 'tablet', 'phone']
    }
  },
  watch: {
    capturing (value) {
      this.realCaptureDate = this.pageData.realCaptureDate
    }
  },
  methods: {
    ...mapMutations([
      'setBookmarkListLayerOptions'
    ]),
    ...mapActions([
      'storeBookmarkCount'
    ]),
    getNodePv (session) {
      return getPercentage(session, this.pageData.sessCnt).toFixed(1) + '%'
    },
    getPercentage (value, total) {
      return getPercentage(value, total).toFixed(1)
    },
    getRank (type, value) {
      const idx = [...this.valueRange[type]].reverse().indexOf(value) + 1
      return this.$options.filters.suffixRank(idx)
    },
    getTopPosition (type, value) {
      if (this.valueRange[type] && this.valueRange[type].length) {
        const max = this.valueRange[type][this.valueRange[type].length - 1]
        const min = this.valueRange[type][0]
        if (value === max) {
          return 0.999999
        }
        if (max !== min) {
          return (value - min) / (max - min)
        } else {
          return 0.999999
        }
      }
      return 0
    },
    getStyle (type, value) {
      let percent = this.getTopPosition(type.replace('Font', ''), value) * this.topStyle[type].length
      return this.topStyle[type][Math.floor(percent)]
    },
    captureType (imagePath) {
      return getS3CaptureType(imagePath)
    },
    captureDate (value) {
      return dateFormatTimezone(value, this.timezoneName, 'YYYY.M.D')
    },
    getS3Url (value) {
      return getS3Url(value)
    },
    moveCarouselLeft () {
      this.carouselPosition = Math.max(this.carouselPosition - 1, 0)
    },
    moveCarouselRight () {
      this.carouselPosition = Math.min(this.carouselPosition + 1, 2)
    },
    moveCarousel (idx) {
      this.carouselPosition = idx
    },
    onCapture (device) {
      if (this.isDemo) return false
      this.$emit('onCapture', this.pageData, device)
    },
    getTrackingPayload (payload) {
      if (this.tracking) {
        const { type, isFromFunnel = false, isAllSelected, excludedMembers = [], selectedMembers = [], memberCacheKey, sessionCacheKey } = this.tracking

        if (type === 'member') {
          payload.memberCacheKey = memberCacheKey
          payload.isAllMemberSelected = isAllSelected && isFromFunnel
          payload.excludedMembers = excludedMembers.map(item => item.id)
          payload.selectedMembers = isAllSelected ? [] : selectedMembers.map(item => item.id)
        } else {
          payload.isAllNonMemberSelected = isAllSelected
          payload.sessionCacheKey = sessionCacheKey
        }
      }
      return payload
    },
    toggleRollbackRanking () {
      this.rollbackRanking = !this.rollbackRanking
      if (this.rollbackRanking) {
        this.loadReferMap()
      } else {
        this.rankingHeight = 0
      }
    },
    loadReferMap () {
      if (!this.referMap) {
        this.rankingHeight = 372
        const payload = {
          device: this.journeyOptions.device,
          start: this.journeyPeriod.start,
          end: this.journeyPeriod.end,
          sid: this.journeyOptions.sid,
          subSid: this.journeyOptions.subSid,
          matchType: this.journeyOptions.matchType,
          exist: this.journeyOptions.exist,
          refer: this.journeyOptions.refer,
          aiRefererIds: this.journeyOptions.aiRefererIds,
          utm: this.journeyOptions.utm,
          survey: this.journeyOptions.survey,
          isCustomNode: this.isCustomNode
        }
        if (this.pageData.isTrend) {
          payload.sequence = this.pageData.sequenceIndex

          if (this.journeyOptions.matchType === 'exact') {
            payload.nodeKey = this.pageData._id
          } else {
            payload.nodeKey = this.isCustomNode ? this.pageData.customId : this.pageData.gUrlId
          }

          getTrendReferMap(payload).then(data => {
            this.onLoadReferMap(data)
          })
        } else {
          payload.firstPathname = this.journeyOptions.firstPath
          payload.treeId = this.pageData.id
          payload.nodeKey = this.pageData.key
          payload.pathStr = this.pageData.pathStr

          this.getTrackingPayload(payload)

          getReferMap(payload).then(data => {
            this.onLoadReferMap(data && data[this.pageData.id])
          })
        }
      } else {
        this.rankingHeight = 5 + this.$refs.referMap.clientHeight
      }
    },
    onLoadReferMap (data) {
      this.referMap = this.makeRanking(data)
      this.$nextTick(() => {
        if (this.referMap.length > 0) {
          this.rankingHeight = 5 + this.$refs.referMap.clientHeight
        }
      })
    },
    makeRanking (data) {
      if (!data) {
        return []
      }
      let list = []
      let idx = 1
      for (let [refer, count] of Object.entries(data)) {
        if (refer && !['null', 'NaN', 'None'].includes(refer) && count !== false) {
          if (refer.substr(0, 4) === 'http') {
            const referObj = document.createElement('a')
            referObj.href = refer
            refer = refer.substr(referObj.protocol.length + 2)
          }

          const domain = this.domain.domain
          const domainForView = getDomainForView(domain)

          if (domain.startsWith('xn--') > -1) {
            if (refer.indexOf(domain) > -1) {
              refer = refer.replace(domain, domainForView)
            }
          }

          let decodeReferUrl = ''
          try {
            decodeReferUrl = decodeURI(refer)
          } catch (e) {
            decodeReferUrl = refer
          }

          list.push({
            rank: idx++,
            url: decodeReferUrl,
            session: count
          })
        }
      }
      return list
    },
    toggleFavorite () {
      const pageData = this.pageData
      if (!pageData.bookmark && this.numBookmarks >= this.numMaxBookmarks) {
        this.setBookmarkListLayerOptions({
          mode: 'manage'
        })
      } else {
        const id = pageData.gUrlId || pageData.key
        const bookmark = {
          sid: this.journeyOptions.sid,
          gUrlId: id,
          addBookmark: !pageData.bookmark
        }

        if (this.journeyOptions.matchType === 'exact') {
          bookmark.url = pageData.url
        }

        if (this.journeyOptions.subSid) {
          bookmark.subSid = this.journeyOptions.subSid
        }

        const updatedKey = this.journeyOptions.matchType === 'exact' ? pageData.url : id

        updateBookmark(bookmark, true)
          .then(response => {
            if (response.updated) {
              EventBus.$emit('updateBookmark', updatedKey, response.bookmark)
              this.$set(pageData, 'bookmark', response.bookmark)
              this.storeBookmarkCount()
            }
          })
          .catch((e) => {
            EventBus.$emit('onError')
          })
      }
    },
    onCheckHeatmap () {
      if (!this.isHeatmapAvailableRange) {
        this.heatmapDisableType = 'range'
        return false
      }

      if (!this.pageData.baApply || !this.pageData.heatmapAid) {
        this.heatmapDisableType = 'noData'
        return false
      }

      if (this.pageData.heatmapUiState === HEATMAP_STATE.ANALYZING) {
        this.heatmapDisableType = 'analyzing'
        return false
      }

      const installDate = this.pageData.baApply.installDate

      if (installDate) {
        const installDateStr = format(utcToLocalTimezone(installDate, this.timezoneName), 'YYYY-MM-DD')

        if (this.journeyPeriod.end < installDateStr) {
          this.heatmapDisableType = 'noData'
          return false
        }
      } else {
        this.heatmapDisableType = 'noData'
        return false
      }
    },
    toggleIncludeUrls () {
      this.showIncludeUrl = !this.showIncludeUrl

      if (this.showIncludeUrl) {
        this.getIncludeUrlList()
      }
    },
    setIncludeUrlData (urls) {
      const domain = this.domain.domain
      const domainForView = getDomainForView(domain)

      if (urls && urls.length > 0 && domain.startsWith('xn--') > -1) {
        const urlsForView = []
        for (let i = 0; i < urls.length; i++) {
          const item = { ...urls[i] }
          if (item.url.indexOf(domain) > -1) {
            item.url = item.url.replace(domain, domainForView)
          }
          urlsForView.push(item)
        }
        this.includeUrlData = urlsForView
      } else {
        this.includeUrlData = urls || []
      }
    },
    getIncludeUrlList () {
      this.includeLoading = true
      const payload = {
        device: this.journeyOptions.device,
        start: this.journeyPeriod.start,
        end: this.journeyPeriod.end,
        sid: this.journeyOptions.sid,
        matchType: this.journeyOptions.matchType,
        exist: this.journeyOptions.exist,
        refer: this.journeyOptions.refer,
        aiRefererIds: this.journeyOptions.aiRefererIds,
        utm: this.journeyOptions.utm,
        survey: this.journeyOptions.survey,
        isCustomNode: this.journeyOptions.isCustomNode
      }
      if (this.pageData.isTargeting) {
        payload.redisKey = this.pageData.redisKey
        payload.targetNodeId = this.targetNodeId
        payload.selectedNodeId = this.journeyOptions.matchType === 'exact'
          ? this.pageData.url
          : (this.journeyOptions.isCustomNode ? this.pageData.customId : this.pageData.gUrlId)
        payload.targetNodeKey = this.journeyOptions.matchType === 'exact'
          ? this.journeyTargetingOptions.targetNodeKey
          : null
        payload.startFromHead = this.lookupOption === 'landing'
        payload.right = this.journeyTargetingOptions.direction === 'forward'
        payload.seq = this.pageData._seq
        payload.tempDFKey = this.targetNodeRedisKey
        getTargetIncludeUrls(payload).then(data => {
          this.setIncludeUrlData(data.urls)
          this.includeLoading = false
        })
      } else {
        payload.subSid = this.journeyOptions.subSid
        payload.firstPathname = this.journeyOptions.firstPath
        payload.nodeKey = getJourneyNodeKey(this.pageData, this.journeyOptions.isCustomNode)
        payload.treeId = this.pageData.id
        payload.pathStr = this.pageData.pathStr
        this.getTrackingPayload(payload)

        getIncludeUrls(payload).then(data => {
          this.setIncludeUrlData(data.urls)
          this.includeLoading = false
        })
      }
    },
    findCategoryName (name, type) {
      switch (type) {
        case 2:
          if (AI_CATEGORY_SECONDARY.find((item) => item === name)) {
            return this.$t(`common.category2.${name}`)
          } else {
            return this.$t(`common.category2.etc`)
          }
        case 3:
          if (AI_CATEGORY_TERTIARY.find((item) => item === name)) {
            return this.$t(`common.category3.${name}`)
          } else {
            return this.$t(`common.category3.etc`)
          }
        default:
          return this.$t(`common.category2.etc`)
      }
    },
    isCategoryNotEtc (name, type) {
      return this.findCategoryName(name, type) !== this.$t(`common.category2.etc`)
    }
  },
  created () {
    this.$emit('targetHeatmapPv', this.pageData.cnt)
    this.realCaptureDate = this.pageData.realCaptureDate
    this.onCheckHeatmap()
  },
  props: [
    'pageData',
    'defaultThumbnail',
    'captureProcessing',
    'valueRange',
    'group',
    'useNullity',
    'timezoneName',
    'originData',
    'targetNodeId',
    'targetNodeRedisKey',
    'lookupOption',
    'isCustomNode',
    'isTracking',
    'tracking'
  ],
  data () {
    return {
      topStyle: {
        dropOff: [3, 2, 1],
        sessionTime: [1, 2, 3]
      },
      rollbackRanking: false,
      rankingHeight: 0,
      realCaptureDate: null,
      heatmapDisableType: null,
      showIncludeUrl: false,
      includeUrlData: [],
      includeLoading: false,
      carouselPosition: 0,
      referMap: null
    }
  }
}
</script>

<style lang="scss" scoped>
.ba-node-report {
  box-sizing: border-box;
  width: 100%;

  a {
    color: inherit;
  }

  i.icon {
    vertical-align: middle;
  }

  .report-header {
    position: relative;
    box-sizing: border-box;
    padding: 40px 20px 14px 20px;
    background-color: #4b5263;

    .category-wrap {
      margin-bottom: 22px;
      .title {
        display: flex;
        align-items: center;
        gap: 6px;
        margin-bottom: 13px;
        > .icon.icon--ai-report-logo {
          width: 20px;
          height: 20px;
        }
        > .text {
          color: white;
          font-size: 14px;
          font-weight: 500;
          line-height: 120%; /* 16.8px */
        }

      }
      .category-detail {
        border-radius: 6px;
        padding: 15px;
        box-sizing: border-box;
        color: #222;
       .secondary {
         display: flex;
         align-items: center;
         gap: 10px;
         > .icon {
           font-size: 26px;
           &:before {
             background: transparent;
           }
         }

         > .secondary-title {
           color: #222;
           font-size: 18px;
           font-weight: 600;
           line-height: 120%; /* 21.6px */
         }
       }

        .line {
          height: 1px;
          width: 100%;
          background: rgba(34, 34, 34, 0.30);
          margin: 13px 0;
        }

        .detail-wrap {
          padding-left: 5px;
          .tertiary {
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            gap: 11px;
            margin-bottom: 6px;

            .icon {
              font-size: 16px;
            }

            .tertiary-title {
              color: #222;
              font-size: 15px;
              font-weight: 500;
              line-height: 120%; /* 18px */
            }
          }
        }
      }

    }

    .group {
      .tag-bullet {
        display: inline-block;
        vertical-align: top;
        width: 12px;
        height: 12px;
        margin-top: 1px;

        span {
          display: block;
          width: 12px;
          height: 12px;
          border-radius: 12px;
          border: 1px solid #ffffff;
        }

        .icon {
          vertical-align: middle;
        }
      }

      .tag-name {
        width: calc(100% - 76px);
        display: inline-block;
        vertical-align: top;
        line-height: 1.38;
        font-size: 13px;
        color: #c1c1c1;
        word-break: break-all;
        margin: 0 0 12px 12px;
        padding: 0 50px 12px 0;
        border-bottom: 1px dashed #888888;
        &.custom {
          border-bottom: initial;
          margin-bottom: 0;
          padding-bottom: 0;
        }
      }
    }

    .url {
      position: relative;
      padding-right: 45px;

      .title {
        position: relative;
        display: block;
        font-size: 18px;
        line-height: 23px;
        font-weight: 500;
        color: #ffffff;
        margin-top: 2px;
        padding-left: 24px;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.19);
        transition: padding-right 0.3s $ease-out-quart;

        i {
          position: absolute;
          top: 4px;
          left: 0;
          margin-right: 5px;
          transform: translateY(-1px);
        }

        &.noTitle {
          font-style: italic;
          color: #d7d7d7;
        }
      }

      .link {
        margin-top: 10px;
        padding-left: 24px;
        line-height: 1.38;
        display: block;
        font-size: 13px;
        color: #c1c1c1;
        word-break: break-all;
      }

      .bookmark-button {
        position: absolute;
        top: -4px;
        right: 0;
      }
    }

    .button-wrap {
      display: block;
      height: 48px;

      &.empty {
        height: 0;
      }

      /deep/ .targeting-button {
        display: inline-block;
        float: left;
        width: calc((100% / 2) - 2.5px);

        & span {
          padding-left: 3px;
        }
      }

      & .heatmap {
        display: inline-block;
        float: right;
        width: calc((100% / 2) - 2.5px);
        height: 48px;
        position: relative;
        padding-top: 12px;
        margin-left: 5px;

        & button {
          border-radius: 6px;
          height: 36px;
          width: 100%;
          border: initial;
          padding-left: 27px;

          &:after {
            border-radius: initial;
          }

          /deep/ .text {
            top: 0;
            left: -50%;
            transform: translate(50%, 0);
          }

          /deep/ .icon {
            top: 50%;
            left: calc(50% - 39px);
            transform: translate(-50%, -50%);
          }

          &.disabled {
            opacity: 1;
            /deep/ .text {
              opacity: 0.2;
            };
          }
        }

        /deep/ .tooltip {
          position: absolute;
          top: 50%;
          right: 30px;
          transform: translate(0, -50%);
          z-index: 9999999;
        }
      }
    }

    .thumbnail-carousel {
      position: relative;
      white-space: nowrap;
      margin-top: 11px;

      .thumbnail-container {
        width: 100%;
        overflow: hidden;

        .thumbnail-wrap {
          transition: margin-left 0.3s cubic-bezier(.28, .12, .42, .94);

          &.custom {
            padding-bottom: 17px;
          }
        }
      }

      .move {
        position: absolute;
        top: calc(50% - 26px);
        width: 28px;
        height: 28px;
        padding-top: 3px;
        border-radius: 5px;
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
        background-color: #fff;
        transition: opacity 0.3s ease;

        svg {
          path {
            stroke: #444444;
            transition: stroke 0.2s ease;
          }
        }

        &:disabled {
          opacity: 0;
          cursor: default;
        }

        &:not(:disabled):hover {
          background-color: #efefef;
        }

        &:not(:disabled):active {
          background-image: linear-gradient(to top, #888888 0%, #666666 100%);
          box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(0, 0, 0, 0.06);
          color: #ffffff;

          svg {
            path {
              stroke: #ffffff;
            }
          }
        }

        &.left {
          left: -15px;
          padding-right: 2px;
        }

        &.right {
          right: -15px;
          padding-left: 2px;
        }
      }

      .bullets {
        text-align: center;
        padding-top: 18px;

        .bullet {
          display: inline-block;
          width: 8px;
          height: 8px;
          margin: 0 5px;
          background-color: #fff;
          opacity: 0.2;
          transition: opacity 0.2s ease;
          border-radius: 5px;
          cursor: pointer;

          &.active {
            opacity: 1;
          }
        }
      }
    }

    .thumbnail {
      position: relative;
      display: inline-block;

      .alert {
        position: absolute;
        width: calc(100% - 50px);
        padding: 8px 0 8px 30px;
        top: 10px;
        left: 50%;
        transform: translateX(-50%);
        border-radius: 2px;
        box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08), 0 2px 3px 0 rgba(0, 0, 0, 0.12);
        background-color: #f4e439;
        color: #555555;
        font-size: 12px;
        z-index: 3;
        text-align: center;

        .icon {
          position: absolute;
          top: 50%;
          left: 4px;
          transform: translateY(-50%);
        }
      }

      .image {
        box-shadow: 0 12px 13px -7px rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.15);
        border: solid 2px #ffffff;
        background-color: #ffffff;
        max-width: 100%;
        border-radius: 10px;
        box-sizing: border-box;
        margin: 0 auto;
        overflow: hidden;
        position: relative;

        .loading {
          position: absolute;
          top: calc(50% - 27px);
          left: calc(50% - 19px);
          padding: 7px;
          border-radius: 8px;
          background-color: #ffffff;
          width: 24px;
          height: 24px;
          z-index: 10;

          .loading-circle {
            position: absolute;
            width: 24px;
            height: 24px;
            transform: translate(-50%, -50%);
            animation: loading 3s linear infinite;
            transition: opacity 0.3s ease;

            svg {
              height: 100%;
            }

            .loading-inner {
              stroke: {
                dashoffset: 0;
                dasharray: 300;
                width: 20;
                miterlimit: 10;
                linecap: round;
              }

              animation: loading-circle 2s linear infinite;
              stroke: $brandColor;
              fill: transparent;
            }
          }
        }

        @keyframes loading {
          0% {
            transform: rotate(0);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        @keyframes loading-circle {
          0% {
            stroke-dashoffset: 0
          }
          100% {
            stroke-dashoffset: -600;
          }
        }

        .capture {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          background-size: cover;
          border-radius: 8px;
        }

        button {
          border-radius: 4px;
          box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.4);
          background-color: #272727;
          color: #ffffff;
          padding: 5px 7px 4px 7px;
          transition: background-color 0.2s ease;
          white-space: nowrap;

          .icon {
            position: relative;
            top: -1px;
            vertical-align: middle;
          }

          &:hover {
            background-color: #4a4a4a;
          }
        }

        .meta {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          box-sizing: border-box;
          background-color: rgba(0, 0, 0, 0.85);
          padding: 19px 15px;
          font-size: 12px;
          color: #ffd418;
          transform: translateY(100%);
          transition: transform 0.3s ease;

          button {
            position: absolute;
            bottom: 9px;
            right: 8px;

            &.disabled {
              opacity: 0.5;
            }
          }
        }

        .buttons {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);

          &.disabled {
            opacity: 0.5;
          }
        }

        &:hover {
          .meta {
            transform: translateY(0);
          }
        }

        &.custom {
          .meta {
            text-align: center;

            & span {
              display: inline-block;
            }
          }

          .value {
            padding: 15px;
            & span {
              color: #FFF;
              font-size: 20px;
              font-style: normal;
              font-weight: 500;
              line-height: normal;
            }
          }
        }
      }

      &.desktop {
        &:after {
          width: 390px;
        }
        .image {
          width: 390px;
          height: 252px;
        }
      }

      &.tablet {
        &:after {
          width: 192px;
        }
        .image {
          width: 192px;
          height: 252px;

          .meta {
            text-align: center;
            padding-top: 10px;
            padding-bottom: 50px;

            button {
              left: 50%;
              bottom: 9px;
              transform: translateX(-50%);
            }
          }
        }
      }

      &.phone {
        &:after {
          width: 162px;
        }
        .image {
          width: 162px;
          height: 252px;

          .meta {
            text-align: center;
            padding-top: 10px;
            padding-bottom: 50px;

            button {
              left: 50%;
              bottom: 9px;
              transform: translateX(-50%);
            }
          }
        }
      }

      &.no-thumbnail {
        .image {
          .capture {
            transform: scale(1.175);
            filter: blur(15px);
          }
        }

        &.tablet,
        &.phone {
          .alert {
            top: 22px;
            width: 257px;
          }
        }
      }
    }
  }

  .report-body {
    padding: 0 20px 35px 20px;

    .session {
      position: relative;
      border-radius: 14px;
      box-shadow: 0 12px 13px -7px rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.15);
      background-color: #ffffff;
      margin: 20px 0;
      padding: 20px;
      font-weight: 500;

      h3 {
        color: #0e90a5;
        font-size: 15px;
        font-weight: 500;
        display: inline-block;
        position: relative;

        .icon {
          margin-right: 7px;
          vertical-align: middle;

          &.icon--info-outline-size17 {
            margin-left: 7px;
          }
        }

        .text {
          display: inline-block;
          vertical-align: middle;
        }

        .bubble {
          position: absolute;
          bottom: 30px;
          left: 12px;
          opacity: 0;
          pointer-events: none;
          transform: translateY(10px);
          transition: opacity 0.2s ease, transform 0.2s ease;
          font-weight: normal;

          & /deep/ .text {
            text-align: left;
          }
        }

        &:hover .bubble {
          opacity: 1;
          transform: translateY(0);
        }
      }

      .total {
        margin: 30px 0 25px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .icon {
          vertical-align: middle;
          margin: 0 8px 0 -3px;
        }

        .value {
          display: inline-flex;
          align-items: baseline;
          vertical-align: middle;
          margin-top: -3px;
          font-size: 42px;
          font-weight: 600;
          flex-wrap: wrap;
          row-gap: 10px;
          // color: #0e90a5;
          span {
            &:last-child {
              color: #89c6d0;
            }
            &:first-child {
              color: #0e90a5;
            }
            &.invalid-value {
              width: 100%;
              padding-right: 25px;
              font-size: 14px;
              font-weight: 500;
              line-height: 1.2;
              & + .all {
                font-size: 18px;
              }
            }
          }
          .icon {
            flex-shrink: 0;
          }
          &.invalid-value {
            max-width: 60%;
            font-size: 14px;
            font-weight: 500;
            line-height: 1.2;
          }
        }
        .toggle-btn {
          position: relative;
          font-size: 11px;
          flex-shrink: 0;
          button {
            border-radius: 13px;
            padding: 7px 9px;
            box-shadow: 0 5px 6px -3px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(0, 0, 0, 0.08);
            background-color: #ffffff;
            line-height: 13px;
            height: 26px;
            &.show {
              background-color: #444;
              color: #fff;
              box-shadow: 0 5px 6px -3px rgba(0, 0, 0, 0.12);
              svg {
                top: -3px;
                transform: scaleY(-1);
                path {
                  stroke: #ffffff;
                }
              }
            }
            svg {
              position: relative;
              top: -1px;
              left: 0;
              transform: none;
              width: 12px;
              height: 12px;
              vertical-align: middle;
              transition: transform 0.2s ease;
              margin-left: 11px;
              path {
                stroke: #444444;
              }
            }

            &:hover:not(.show) {
              background-color: #efefef;
            }
          }
        }
        .all {
          font-size: 22px;
          color: #89c6d0;
          margin-left: 6px;
        }
      }

      .more-info {
        li {
          position: relative;
          border-bottom: 1px solid #d8d8d8;

          h4 {
            width: 120px;
            font-size: 14px;
            position: absolute;
            top: calc(50% + 1px);
            left: 0;
            z-index: 2;
            transform: translateY(-50%);

            .bubble {
              position: absolute;
              bottom: calc(100% + 12px);
              left: -10px;
              opacity: 0;
              transform: translateY(10px);
              transition: opacity 0.2s ease, transform 0.2s ease;
              pointer-events: none;

              & /deep/ .text {
                text-align: left;
              }
            }

            &:hover .bubble {
              opacity: 1;
              transform: translateY(0);
            }
          }

          .value {
            padding: 14px 25px 14px 111px;
            display: block;
            font-weight: 600;
            font-size: 16px;
            line-height: 1;

            .rankCount {
              display: flex;
              flex-wrap: wrap;
              gap: 5px;
              max-width: 150px;
              &.all {
                color: #ffbb9f;
                display: block;
                margin-top: 9px;
              }
            }

            .percent {
              font-size: 14px;
              font-weight: 400;
            }

            .rank {
              position: absolute;
              right: 48px;
              top: 50%;
              font-weight: normal;
              display: inline-block;
              border: 1px solid;
              padding: 2px 5px;
              border-radius: 3px;
              font-size: 12px;
              transform: translateY(-50%);
            }

            .icon {
              position: absolute;
              top: 50%;
              right: 0;
              transform: scale(1.2) translateY(-40%) translateX(-10%);
            }
          }

          &.time {
            color: #4b8f0d;

            .rank {
              border-color: #4b8f0d;
            }
          }

          &.dropoff {
            color: #ff4a00;
            &.ja {
              .value {
                padding-top: 20px;
                padding-bottom: 20px;
              }
            }

            .rank {
              border-color: #ff4a00;
            }
          }

          &.nullity {
            color: #767676;

            .rank {
              border-color: #767676;
            }
          }
          &.refresh {
            color: #0074ff;
            .value {
              padding-right: 0;
            }
            .rank {
              border-color: #0074ff;
            }
          }

          &.rollback {
            color: #9665e3;
            .value {
              padding-right: 0;
            }
            .rank {
              border-color: #9665e3;
            }

            .per {
              position: relative;
            }

            .see-rank {
              position: relative;
              clear: both;
              border-top: 1px dashed rgba(0, 0, 0, 0.16);
              padding: 16px 0 10px 0;
              margin-top: 15px;
              font-weight: normal;
              color: #666666;
              font-size: 13px;

              .number {
                font-weight: 500;
                color: #9665e3;
              }

              button {
                margin-top: 8px;
                position: absolute;
                top: calc(50% + 2px);
                right: 0;
                transform: translateY(-50%);
                border-radius: 13px;
                box-shadow: 0 5px 6px -3px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(0, 0, 0, 0.08);
                background-color: #ffffff;
                padding: 7px 8px 7px 9px;
                font-size: 11px;
                font-weight: 500;
                color: #9665e3;
                vertical-align: middle;
                transition: color 0.2s ease,
                            background-color 0.2s ease,
                            box-shadow 0.2s ease;

                svg {
                  position: relative;
                  top: -1px;
                  left: 0;
                  transform: none;
                  width: 12px;
                  height: 12px;
                  vertical-align: middle;
                  margin-left: 11px;
                  transition: transform 0.2s ease;

                  path {
                    stroke: #444444;
                  }
                }

                &:hover {
                  background-color: #efefef;
                }

                &:active,
                &.active {
                  background-color: #9665e3;
                  color: #ffffff;
                  box-shadow: 0 5px 6px -3px rgba(0, 0, 0, 0.12);

                  svg {
                    transform: scaleY(-1);

                    path {
                      stroke: #ffffff;
                    }
                  }
                }
              }
            }
          }

          &:last-child {
            // border-bottom: none;
          }
        }

        &.with-thru-info {
          li:last-child {
              border-bottom: none;
            }
          h4 {
            top: 21px;
          }

          li.en h4 {
            top: 22px;
          }

          li.ja h4 {
            top: 35px;
          }

          .value .icon {
            top: 20px;
          }

          li.ja .value .icon {
            top: 25px;
          }
        }
      }
      .ranking {
        position: relative;
        overflow: hidden;
        transition: height 0.5s ease,
                    opacity 0.5s ease,
                    margin-top 0.5s ease;

        &.hidden {
          .loading {
            opacity: 0;
          }

          .for-free {
            opacity: 0;
          }
        }

        .loading {
          position: absolute;
          left: 0;
          top: 123px;
          width: 100%;
          height: calc(100% - 129px);
          color: #666666;
          transition: opacity 0.3s ease, height 0.5s ease;
          opacity: 1;
          border-bottom: 1px solid #ebebeb;
          overflow: hidden;

          &.free {
            top: 34px;
            height: calc(100% - 34px);
          }

          &.disabled {
            opacity: 0;
            height: 0 !important;
          }

          .loading {
            height: auto;
          }
        }

        .for-free {
          position: absolute;
          top: 50%;
          left: 0;
          width: 100%;
          transform: translateY(-50%);
          text-align: center;
          opacity: 1;
          transition: opacity 0.3s ease;

          p {
            margin-top: 10px;
            font-size: 13px;
            line-height: 1.54;
            color: #2f2f2f;

            & /deep/ span {
              color: #7e36e0;
            }
          }
        }

        .referMap {
          .notice {
            position: relative;
            font-size: 12px;
            line-height: 1.5;
            color: #9665e3;
            padding: 25px 0 28px 27px;

            i {
              position: absolute;
              top: 25px;
              left: 2px;
            }
          }

          tbody {
            transition: opacity 0.3s ease;
            opacity: 1;
          }

          &.disabled {
            tbody {
              opacity: 0;
            }
          }

          table {
            font-size: 13px;
            width: 100%;

            th {
              font-weight: 500;
              font-stretch: normal;
              font-style: normal;
              line-height: 1;
              letter-spacing: normal;
              color: #767676;
              padding: 13px 10px 7px 10px;
              border-bottom: 1px solid #bbbbbb;
              font-size: 13px;

              &.item--rank {
                text-align: center;
                padding-right: 0;
                padding-left: 0;
              }

              &.item--url {
                text-align: center;
              }

              &.item--session {
                text-align: right;
                padding-right: 0;
                padding-left: 0;
              }
            }

            td {
              border-bottom: 1px solid #ebebeb;
              vertical-align: middle;
              line-height: 1.23;
              font-size: 13px;
              font-weight: normal;
              color: #777777;

              &.item--rank {
                padding: 16px 0;
                width: 40px;
                line-height: 18px;
                font-size: 14px;
                text-align: center;

                &.big {
                  font-size: 12px;
                }
              }

              &.item--url {
                line-height: 14px;
                padding: 10px;

                .url {
                  word-break: break-all;
                }
              }

              &.item--session {
                text-align: right;
                width: 55px;
                white-space: nowrap;
                padding: 10px 0;

                &.big {
                  font-size: 12px;
                }
              }
            }
          }
        }
      }
    }

    .pageview {
      position: relative;
      font-weight: 500;

      h3 {
        color: #555555;
        font-size: 15px;
        font-weight: 500;
        display: inline-block;
        position: relative;

        .icon {
          margin-right: 7px;
          vertical-align: middle;

          &.icon--info-outline-size17 {
            margin-left: 7px;
          }
        }

        .text {
          display: inline-block;
          vertical-align: middle;
        }

        .bubble {
          position: absolute;
          bottom: 30px;
          left: 12px;
          opacity: 0;
          transform: translateY(10px);
          transition: opacity 0.2s ease, transform 0.2s ease;
          pointer-events: none;
          font-weight: normal;

          & /deep/ .text {
            text-align: left;
          }
        }

        &:hover .bubble {
          opacity: 1;
          transform: translateY(0);
        }
      }

      .total {
        color: #555555;
        font-size: 32px;
        font-weight: 500;
        width: 142px;
        height: 128px;
        padding-top: 57px;
        margin-left: 2px;
        white-space: nowrap;

        &.small {
          font-size: 22px;
          padding-top: 67px;
          height: 118px;
        }

        .value {
          display: block;
          font-size: 13px;
          line-height: 1.23;
          font-weight: normal;
          margin-top: 5px;
        }
      }

      .chart {
        position: absolute;
        top: 62px;
        right: 20px;
        width: 142px;
        height: 142px;
      }

      .more-info {
        li {
          position: relative;

          h4 {
            width: 90px;
            font-size: 14px;
            position: absolute;
            top: 15px;
            left: 0;
            transform: translateY(0);
            z-index: 2;

            .bubble {
              position: absolute;
              bottom: calc(100% + 12px);
              left: -10px;
              opacity: 0;
              transform: translateY(10px);
              transition: opacity 0.2s ease, transform 0.2s ease;
              pointer-events: none;

              & /deep/ .text {
                text-align: left;
              }
            }

            &:hover .bubble {
              opacity: 1;
              transform: translateY(0);
            }
          }

          .value {
            padding: 14px 0 14px 111px;
            display: block;
            font-size: 14px;

            .percent {
              font-size: 16px;
              font-weight: 400;
            }

            .description {
              display: block;
              font-size: 16px;
              &.sub {
                margin-top: 2px;
                font-size: 12px;
              }

              &.ja {
                line-height: 21px;
              }
            }

            .rank {
              position: absolute;
              top: 50%;
              right: 48px;
              transform: translateY(-50%);
              font-weight: normal;
              display: inline-block;
              border: 1px solid;
              border-radius: 3px;
              font-size: 12px;
              padding: 2px 5px;
            }

            .icon {
              position: absolute;
              top: 50%;
              right: 0;
              transform: scale(1.2) translateY(-40%) translateX(-10%);
            }
          }

          &.refresh {
            color: #0074ff;

            .rank {
              border-color: #0074ff;
            }
          }

          &.rollback {
            color: #9665e3;

            .rank {
              border-color: #9665e3;
            }

            .per {
              position: relative;
            }

            .see-rank {
              position: relative;
              clear: both;
              border-top: 1px dashed rgba(0, 0, 0, 0.16);
              padding: 16px 0 10px 0;
              margin-top: 14px;
              font-weight: normal;
              color: #666666;
              font-size: 13px;

              .number {
                font-weight: 500;
                color: #9665e3;
              }

              button {
                margin-top: 8px;
                position: absolute;
                top: calc(50% + 2px);
                right: 0;
                transform: translateY(-50%);
                border-radius: 13px;
                box-shadow: 0 5px 6px -3px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(0, 0, 0, 0.08);
                background-color: #ffffff;
                padding: 7px 8px 7px 9px;
                font-size: 11px;
                font-weight: 500;
                color: #9665e3;
                vertical-align: middle;
                transition: color 0.2s ease,
                            background-color 0.2s ease,
                            box-shadow 0.2s ease;

                svg {
                  position: relative;
                  top: -1px;
                  left: 0;
                  transform: none;
                  width: 12px;
                  height: 12px;
                  vertical-align: middle;
                  margin-left: 11px;
                  transition: transform 0.2s ease;

                  path {
                    stroke: #444444;
                  }
                }

                &:hover {
                  background-color: #efefef;
                }

                &:active,
                &.active {
                  background-color: #9665e3;
                  color: #ffffff;
                  box-shadow: 0 5px 6px -3px rgba(0, 0, 0, 0.12);

                  svg {
                    transform: scaleY(-1);

                    path {
                      stroke: #ffffff;
                    }
                  }
                }
              }
            }
          }

          &:last-child {
            border-bottom: none;
          }
        }
      }

      .ranking {
        position: relative;
        overflow: hidden;
        transition: height 0.5s ease,
                    opacity 0.5s ease,
                    margin-top 0.5s ease;

        &.hidden {
          .loading {
            opacity: 0;
          }

          .for-free {
            opacity: 0;
          }
        }

        .loading {
          position: absolute;
          left: 0;
          top: 123px;
          width: 100%;
          height: calc(100% - 129px);
          color: #666666;
          transition: opacity 0.3s ease, height 0.5s ease;
          opacity: 1;
          border-bottom: 1px solid #ebebeb;
          overflow: hidden;

          &.free {
            top: 34px;
            height: calc(100% - 34px);
          }

          &.disabled {
            opacity: 0;
            height: 0 !important;
          }

          .loading {
            height: auto;
          }
        }

        .for-free {
          position: absolute;
          top: 50%;
          left: 0;
          width: 100%;
          transform: translateY(-50%);
          text-align: center;
          opacity: 1;
          transition: opacity 0.3s ease;

          p {
            margin-top: 10px;
            font-size: 13px;
            line-height: 1.54;
            color: #2f2f2f;

            & /deep/ span {
              color: #7e36e0;
            }
          }
        }

        .referMap {
          .notice {
            position: relative;
            font-size: 12px;
            line-height: 1.5;
            color: #9665e3;
            padding: 25px 0 28px 27px;

            i {
              position: absolute;
              top: 25px;
              left: 2px;
            }
          }

          tbody {
            transition: opacity 0.3s ease;
            opacity: 1;
          }

          &.disabled {
            tbody {
              opacity: 0;
            }
          }

          table {
            font-size: 13px;
            width: 100%;

            th {
              font-weight: 500;
              font-stretch: normal;
              font-style: normal;
              line-height: 1;
              letter-spacing: normal;
              color: #767676;
              padding: 13px 10px 7px 10px;
              border-bottom: 1px solid #bbbbbb;
              font-size: 13px;

              &.item--rank {
                text-align: center;
                padding-right: 0;
                padding-left: 0;
              }

              &.item--url {
                text-align: center;
              }

              &.item--session {
                text-align: right;
                padding-right: 0;
                padding-left: 0;
              }
            }

            td {
              border-bottom: 1px solid #ebebeb;
              vertical-align: middle;
              line-height: 1.23;
              font-size: 13px;
              font-weight: normal;
              color: #777777;

              &.item--rank {
                padding: 16px 0;
                width: 40px;
                line-height: 18px;
                font-size: 14px;
                text-align: center;

                &.big {
                  font-size: 12px;
                }
              }

              &.item--url {
                line-height: 14px;
                padding: 10px;

                .url {
                  word-break: break-all;
                }
              }

              &.item--session {
                text-align: right;
                width: 55px;
                white-space: nowrap;
                padding: 10px 0;

                &.big {
                  font-size: 12px;
                }
              }
            }
          }
        }
      }
    }
  }
  &.shared {
    .bookmark-button  /deep/ {
      pointer-events: none;
      .button {
        background-color: transparent;
        box-shadow: none;
        opacity: .3;
      }
    }
  }

  .fade-enter-active {
    transition: opacity 0.5s ease;
    z-index: 1;
  }
  .fade-leave-active {
    transition: opacity 0.3s ease;
    z-index: 1;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  .btn__back-to-top {
    margin-top: 50px;
    margin-bottom: -20px !important;
  }
}
</style>
